import styled from 'styled-components';

export const SAccordionContainer = styled.div`
    display: flex;
    flex-direction: column;
`;
